import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Stack,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import zhTW from "date-fns/locale/zh-TW";
import { zhHK } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import { useTheme } from "@mui/material/styles";

import setCoupon from "../../../api/coupon/setCoupon";


const defaultCoupon = {
  Id: "",
  Name: "",
  Description: "",
  Price: 100,
  Percentage: 0,
  IsValid: true,
  ValidDays: 30,
  StartDate: new Date().toISOString(),
  EndDate: new Date().toISOString(),
  CanBeSold: false,
  Points: 10,
  UsageCity: "",
  UsageLimit: 1,
  UsageCount: 0,
  MinOrderValue: 0,
  CreatedAt: new Date().toISOString(),
  UpdatedAt: new Date().toISOString(),
};
export default function CouponDialog({ coupon, isAdd, open, setOpen }) {
  const theme = useTheme();
  const [couponData, setCouponData] = useState(defaultCoupon);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  useEffect(() => {
    if (!isAdd) {
      setCouponData(coupon);
    } else {
      setCouponData(defaultCoupon);
    }
  }, [open]);

  const CustomActionBar = ({
    onAccept,
    onClear,
    onCancel,
    onSetToday,
    actions,
    className,
  }) => (
    <DialogActions
      className={className}
      sx={{ justifyContent: "space-between" }}
    >
      <Button variant="outlined" color="info" onClick={onCancel}>
        取消
      </Button>
      <Button variant="outlined" color="info" onClick={onAccept}>
        確認
      </Button>
    </DialogActions>
  );
  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;
    setCouponData((prevCoupon) => ({
      ...prevCoupon,
      [name]:
        type === "checkbox"
          ? checked
          : type === "number"
          ? Number(value)
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await setCoupon(couponData);
      handleClose()
      setIsSuccess(true);
      // ... additional success logic
    } catch (err) {
      setError(err.message);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog maxWidth={"80%"} open={open} onClose={handleClose}>
      <DialogTitle>{!isAdd ? "編輯優惠券" : "新增優惠券"}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={2} direction="column">
            <TextField
              label="編號"
              name="Id"
              color="info"
              disabled={!isAdd}
              value={couponData.Id || ""}
              onChange={handleChange}
            />
            <TextField
              label="名稱"
              name="Name"
              color="info"
              value={couponData.Name || ""}
              onChange={handleChange}
            />
            <TextField
              label="描述"
              name="Description"
              color="info"
              value={couponData.Description || ""}
              onChange={handleChange}
            />
            <TextField
              label="折扣金額"
              name="Price"
              color="info"
              type="number"
              value={couponData.Price || ""}
              onChange={handleChange}
            />
            {/* ... add more input fields as per your requirements ... */}
            <FormControlLabel
              control={
                <Checkbox
                  name="IsValid"
                  color={"info"}
                  checked={couponData.IsValid|| true}
                  onChange={handleChange}
                />
              }
              label="有效的"
            />

            <FormControlLabel
              control={
                <Checkbox
                  name="CanBeSold"
                  color={"info"}
                  checked={couponData.CanBeSold|| false}
                  onChange={handleChange}
                />
              }
              label="可以被兌換"
            />
            <TextField
              label="兌換後有效天數"
              disabled={!couponData.CanBeSold}
              name="ValidDays"
              color="info"
              type="number"
              value={couponData.ValidDays || ""}
              onChange={handleChange}
            />
            <TextField
              label="兌換點數"
              disabled={!couponData.CanBeSold}
              name="Points"
              color="info"
              type="number"
              value={couponData.Points || ""}
              onChange={handleChange}
            />
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              localeText={
                zhHK.components.MuiLocalizationProvider.defaultProps.localeText
              }
              adapterLocale={zhTW}
            >
              <DatePicker
                label="開始日期"
                name="StartDate"
                slots={{ actionBar: CustomActionBar }}
                slotProps={{
                  openPickerIcon: { fontSize: "large" },
                  openPickerButton: { color: "secondary" },
                  textField: {
                    color: "info",
                  },
                }}
                dayOfWeekFormatter={(_day, date) => {
                  format(date, "EEEEEE");
                }}
                format="yyyy/MM/dd"
                defaultValue={new Date(couponData.StartDate)}
                value={new Date(couponData.StartDate)}
                onChange={(newValue) =>
                  setCouponData((prev) => ({
                    ...prev,
                    StartDate: newValue.toISOString(),
                  }))
                }
              />
              <DatePicker
                label="結束日期"
                name="EndDate"
                slots={{ actionBar: CustomActionBar }}
                slotProps={{
                  openPickerIcon: { fontSize: "large" },
                  openPickerButton: { color: "secondary" },
                  textField: {
                    color: "info",
                  },
                }}
                dayOfWeekFormatter={(_day, date) => {
                  format(date, "EEEEEE");
                }}
                format="yyyy/MM/dd"
                defaultValue={new Date(couponData.EndDate)}
                value={new Date(couponData.EndDate)}
                onChange={(newValue) =>
                  setCouponData((prev) => ({
                    ...prev,
                    EndDate: newValue.toISOString(),
                  }))
                }
              />
            </LocalizationProvider>

            <Button variant="contained" color="info" type="submit">
            {!isAdd ? "編輯優惠券" : "新增優惠券"}
            </Button>
          </Stack>
        </DialogContent>
      </form>
    </Dialog>
  );
}
